export const getPhotosFromDB = (state) => {
  return state.object?.photo?.photos;
};

export const getRejectedPhotosFromDB = (state) =>
  state.object?.photo?.rejectedPhotos;
